<template>

  <div class="">
    <app-header/>
    
    <div class="container">

      <div class="row">

        <div class="col-sm-12">
          <div class="box-dashboard">
            <div class="bd-header">
              Total Consignaciones
            </div>

            <div class="bd-body expo">
              <h2>${{money(total)}}</h2>
              <p>Dinero en recaudos</p>
            </div>
          </div>
        </div>

        
      </div>

      <div class="box-btn">
        <div class="float-right">
          <button type="button" v-b-modal.modalFilter class="btn btn-primary">
            Filtrar
          </button>
        </div>

        <div class="d-inline mr-4">
          <button type="button" v-can="'consignment.reportConsigment'" v-b-modal.reportConsignment class="btn btn-primary">
            Reportar Consignación
          </button>
        </div>

        <div class="d-inline">
          <button type="button" v-on:click="generateCVS()" class="btn btn-primary">
            CSV
          </button>
        </div>
      </div>

      <div class="table table-padded">

        <b-card>
          <b-row>
            <b-col md="6" class="my-1">
              <b-form-group horizontal label="Buscador" class="mb-0">
                <b-input-group>
                  <b-form-input v-model="filter" />
                  <b-input-group-append>
                    <b-btn :disabled="!filter" @click="filter = ''">Limpiar</b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>


            <b-col md="6" class="my-1">
              <b-form-group horizontal label="Por página" class="mb-0">
                <b-form-select :options="pageOptions" v-model="perPage" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-table
          
          :items="consignments"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          @filtered="onFiltered" class="table table-padded">

          <template slot="id" slot-scope="row">
            {{row.item.id}}
          </template>

          <template slot="status" slot-scope="row">
           <template v-if="row.item.status == 2">
            Aprobada
          </template>
          <template v-else-if="row.item.status == 3">
            Reversada
          </template>
          <template v-else-if="row.item.status == 1">
            Pendiente
          </template>
          <template v-else>
            Rechazada
          </template>
        </template>

        <template slot="type" slot-scope="row">
          <template v-if="row.item.eTransfer == 1">
            Transferencia
          </template>

          <template v-else>
            Consignación
          </template>

          
        </template>

        <template slot="createdAt" slot-scope="row">
         {{row.item.createdAt.substr(0, 10)}}
       </template>

       <template slot="createdAtHour" slot-scope="row">
         {{row.item.createdAt.substr(11, 5)}}
       </template>

       <template slot="date" slot-scope="row">
         {{row.item.date.substr(0, 10)}}
       </template>

       <template slot="hour" slot-scope="row">
         {{row.item.date.substr(11, 5)}}
       </template>

       <template slot="bankImage" slot-scope="row">
        <img :src="'/banks/'+row.item.bankImage" class="bank">
      </template> 

      <template slot="amount" slot-scope="row">
        ${{money(row.item.amount)}}
      </template>

      <template slot="relAmount" slot-scope="row">
        <h2 class="itemIndicator" :class="row.item.type == 'add' ? 'low' : ''">${{money(row.item.relAmount)}}</h2>
      </template>

      <template slot="action" slot-scope="row">
        <button v-if="row.item.image" v-b-modal.modalImage v-on:click="viewImage(row.item)" type="button" class="btn btn-primary">
          Anexo
        </button>   

        <template v-if="row.item.observation != null">
          <button v-b-modal.modalObservation v-on:click="viewObservation(row.item)" type="button" class="actionBtnTable nobtn">
            <i class="material-icons" style="color: #dab51b;">assignment</i>
          </button>
        </template>          
      </template>

        </b-table>

        <b-row>
          <b-col md="12" class="my-1 float-right">
            <b-pagination :total-rows="consignments.length" :per-page="perPage" v-model="currentPage" class="my-0" />
          </b-col>
        </b-row>

        <app-pagination :data="data"/>


        
      </b-card >

    </div>

  </div>
  
  <app-footer/>

  <b-modal id="modalFilter" ref="modalFilter" title="Filtrar" hide-footer>

    <form v-on:submit.prevent="read">
      <div class="form-group">
        <label>Referencia de pago</label>
        <input type="text" class="form-control" v-model="filters.payReference">
      </div>

      <div class="form-group">
        <label>Fecha Inicial</label>
        <input type="date" class="form-control" v-model="filters.dateStart">
      </div>

      <div class="form-group">
        <label>Fecha Final</label>
        <input type="date" class="form-control" v-model="filters.dateEnd">
      </div>

      <div class="form-group">
        <label class='control-label'>Fecha de aprobación inicial</label>   
        <input type="date"  class="form-control" v-model='filters.updatedStart'>   
      </div>

      <div class="form-group"> 
        <label class='control-label'>Fecha de aprobación final</label>   
        <input type="date"  class="form-control" v-model='filters.updatedEnd'>   
      </div>

      <div class="form-group">
        <label>Banco</label>
        <select class="form-control" v-model="filters.bankId">
          <option v-for="(bank, index) in banks" :key="index" :value="bank.id">
            {{bank.name}}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label class='control-label'>Estado</label>
        <select class="form-control" v-model="filters.status">
          <option value="1" >Pendiente</option>
          <option value="2" >Aprobada</option>
          <option value="0" >Rechazada</option>
        </select> 
      </div>

      <div class="d-inline mr-4">
        <button type="submit" v-on:click="clearFilter()" class="btn btn-primary">Limpiar
        </button>
      </div>
      <div class="d-inline">
        <button type="submit" class="btn btn-primary">Filtrar</button>
      </div>
    </form>
  </b-modal>

  <b-modal id="reportConsignment" ref="reportConsignment" title="Reportar Consignación" hide-footer>

    <form v-on:submit.prevent="reportConsignment" ref="reportConsignmentForm">
      <div class="form-group">
        <label>Tarjeta de Recaudo</label>
        <input type="text" class="form-control" name="reference">
      </div>

      <div class="form-group">
        <label>Fecha Consignación</label>
        <input type="date" class="form-control" name="dateConsignment">
      </div>

      <div class="form-group">
        <label>Hora Consignación</label>
        <input type="time" step="1" class="form-control" name="hourConsignment">
      </div>


      <div class="form-group">
        <label>Banco</label>
        <select class="form-control" name="bankId">
          <option v-for="(bank, index) in banks" :key="index" :value="bank.id">
            {{bank.name}}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label>Valor</label>
        <money  name="value" class="form-control" v-model="amountForm"/>
      </div>

      <div class="form-group">
        <label>Anexo</label>
        <input type="file" name='file' class="form-control" >
      </div>

      <div class="form-group">
        <label>Observación</label>
        <textarea type="text" class="form-control" name="observation"></textarea>
      </div>

      <button type="submit" class="btn btn-primary">Reportar consignación</button>

      
    </form>

  </b-modal>
  <b-modal id="modalObservation" ref="modalObservation" centered hide-footer class='box-modal' title = "Observación del Administrador">
    <div>
      {{currentObservation.observation}}
    </div>
  </b-modal>
  <b-modal id="modalImage" title="Visualizar anexo">
    <img :src="current.image">
  </b-modal>



</div>
</template>


<script>
import { mapGetters } from "vuex";
import {
  FETCH_CONSIGNMENTS,
  FETCH_BANKS,
  REPORT_CONSIGNMENT
} from "@/store/actions.type";

import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import AppPagination from "@/components/AppPagination.vue";

export default {
  components: {
    AppHeader,
    AppFooter,
    AppPagination
  },
  data: function() {
    return {
      current: {},
      filters: {
        payReference: "",
        reportDate: "",
        user: "",
        bankId: "",
        dateStart: this.formatDate(Date.now()),
        dateEnd: this.formatDate(Date.now())
      },
      currentObservation: "",
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 20, 30, 40, 50],
      filter: null,
      report: {},
      data: {},
      amountForm: 0,
      fields: [
        { key: "id", label: "Id", sorteable: true },
        { key: "status", label: "Estado", sorteable: true },
        { key: "type", label: "Tipo", sorteable: true },
        { key: "createdAt", label: "Fecha", sorteable: true },
        { key: "createdAtHour", label: "Hora", sorteable: true },
        { key: "reference", label: "Referencia", sorteable: true },
        { key: "date", label: "Fecha consignación", sorteable: true },
        { key: "hour", label: "Hora consignación", sorteable: true },
        { key: "bankImage", label: "Imagen", sorteable: true },
        { key: "amount", label: "Valor", sorteable: true },
        { key: "relAmount", label: "Valor Neto", sorteable: true },
        { key: "action", label: "Acción", sorteable: true }
      ]
    };
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    read() {
      this.$refs.modalFilter.hide();
      this.$store.dispatch(FETCH_CONSIGNMENTS, this.filters);
    },

    clearFilter() {
      (this.filters = {}), this.read();
    },
    viewImage(consignment) {
      this.current = consignment;
    },

    viewObservation(consignment) {
      this.currentObservation = consignment;
    },

    reportConsignment() {
      let form = this.$refs.reportConsignmentForm;
      let formData = new FormData(form);

      this.$store
        .dispatch(REPORT_CONSIGNMENT, formData)
        .then(result => {
          this.$refs.reportConsignmentForm.reset();
          this.read();
          this.$refs.reportConsignment.hide();
          this.$snotify.success(result.message);
        })
        .catch(error => {
          this.$snotify.error(error.message);
        });
    },

    generateCVS() {
      var rows = this.consignments.map(item => {
        var status = "";
        let cost = item.amount - item.relAmount;
        if (item.status == 2) {
          status = "Aprobada";
        } else if (item.status == 1) {
          status = "Pendiente";
        } else if (item.status == 3) {
          status = "Reversada";
        } else {
          status = "Rechazada";
        }

        return [
          item.id,
          status,
          item.createdAt.substr(0, 10),
          item.createdAt.substr(11, 5),
          item.updatedAt.substr(0, 10),
          item.updatedAt.substr(11, 5),
          "" + item.reference,
          item.date.substr(0, 10),
          item.date.substr(11, 5),
          item.bankName,
          "$" + Math.round(item.amount),
          "$" + Math.round(item.relAmount),
          "$" + Math.round(cost)
        ];
      });

      rows = [
        [
          "Id",
          "Estado",
          "Fecha",
          "Hora",
          "Fecha Aprob",
          "Hora Aprob",
          "Referencia Pago",
          "Fecha Consignacion",
          "Hora Consignación",
          "Banco",
          "Valor",
          "Valor Neto",
          "Costo Bancario"
        ],
        ...rows,
        ["", "", "", "", "", "", "", "", "", "", "", "", ""]
      ];

      let csvContent = "";
      rows.forEach(function(rowArray) {
        rowArray = rowArray.map(c => `"${c}"`);
        let row = rowArray.join(";");
        csvContent += row + "\r\n";
      });

      var csvData = new Blob([csvContent], { type: "text/csv" });
      var csvUrl = URL.createObjectURL(csvData);

      var hiddenElement = document.createElement("a");
      hiddenElement.href = csvUrl;
      hiddenElement.target = "_blank";
      hiddenElement.download = "Consignaciones.csv";
      hiddenElement.click();
    }
  },

  computed: {
    ...mapGetters(["user", "consignments", "banks"]),
    total: function() {
      var total = 0;
      this.consignments.map(row => {
        if (row.status == 2 || row.status == 3) {
          total += row.relAmount;
        }
      });
      return total;
    }
  },

  mounted() {
    this.read();
    this.$store.dispatch(FETCH_BANKS);
  }
};
</script>


<style lang="scss">
</style>
